module.exports = __webpack_public_path__ + "img/12.881b41d6.png";